import { Component, OnInit } from '@angular/core';
import * as fileSaver from 'file-saver';
declare var gtag;
declare var ga;
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  informationURL: any;
  constructor() { }

  ngOnInit() {
  }
  downloadTemplate(shipmentType) {
    if (shipmentType === 'hhg') {
      gtag('event', 'file_download', {
        'file_name': 'CHAMP Shipment Reporting Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'CHAMP Shipment Reporting Template.xlsx'});
      gtag('event', 'click', {
        'file_name': 'CHAMP Shipment Reporting Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'CHAMP Shipment Reporting Template.xlsx'});
      fileSaver.saveAs('../../../assets/templates/CHAMP Shipment Reporting Template.xlsx', 'CHAMP Shipment Reporting Template.xlsx');
    } else if (shipmentType === 'frt') {
      gtag('event', 'file_download', {
        'file_name': 'Freight_ShipmentReportUpload_template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'Freight_ShipmentReportUpload_template.xlsx'});
      gtag('event', 'click', {
        'file_name': 'Freight_ShipmentReportUpload_template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'Freight_ShipmentReportUpload_template.xlsx'});
      fileSaver.saveAs('../../../assets/templates/Freight_ShipmentReportUpload_template.xlsx', 'Freight_ShipmentReport_Template.xlsx');
    } else if (shipmentType === 'carrier') {
      gtag('event', 'file_download', {
        'file_name': 'CHAMP GSA 3080 Reporting Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'CHAMP GSA 3080 Reporting Template.xlsx'});
      gtag('event', 'click', {
        'file_name': 'CHAMP GSA 3080 Reporting Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'CHAMP GSA 3080 Reporting Template.xlsx'});
      fileSaver.saveAs('../../../assets/templates/CHAMP GSA 3080 Reporting Template.xlsx', 'CHAMP GSA 3080 Reporting Template.xlsx');
    } else if (shipmentType === 'sit') {
      gtag('event', 'file_download', {
        'file_name': 'CHAMP SIT Reporting Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'CHAMP SIT Reporting Template.xlsx'});
      gtag('event', 'click', {
        'file_name': 'CHAMP SIT Reporting Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'CHAMP SIT Reporting Template.xlsx'});
      fileSaver.saveAs('../../../assets/templates/CHAMP SIT Reporting Template.xlsx', 'CHAMP SIT Reporting Template.xlsx');
    } else if (shipmentType === 'userGuide') {
      gtag('event', 'file_download', {
        'file_name': 'TMSS_2.0_Household_Goods_User_Guide.xlsx',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'TMSS_2.0_Household_Goods_User_Guide.xlsx'});
      gtag('event', 'click', {
        'file_name': 'TMSS_2.0_Household_Goods_User_Guide.xlsx',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'TMSS_2.0_Household_Goods_User_Guide.xlsx'});
      fileSaver.saveAs('../../../assets/templates/TMSS_2.0_Household_Goods_User_Guide.pdf', 'User Guide HHG.pdf');
    } else if (shipmentType === 'frtagyuserGuide') {
      gtag('event', 'file_download', {
        'file_name': 'FRT Agency User Guide.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'FRT Agency User Guide.pdf'});
      gtag('event', 'click', {
        'file_name': 'FRT Agency User Guide.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'FRT Agency User Guide.pdf'});
      fileSaver.saveAs('../../../assets/templates/Agency User Guide.pdf', 'FRT Agency User Guide.pdf');
    } else if (shipmentType === 'frttspuserGuide') {
      gtag('event', 'file_download', {
        'file_name': 'TSP User Guide.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'TSP User Guide.pdf'});
      gtag('event', 'click', {
        'file_name': 'TSP User Guide.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'TSP User Guide.pdf'});
      fileSaver.saveAs('../../../assets/templates/TSP User Guide.pdf', 'FRT TSP User Guide.pdf');
    } else if (shipmentType === 'tspmonthlyreport') {
      gtag('event', 'file_download', {
        'file_name': 'TSP Monthly Report 2025.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'TSP Monthly Report 2025.xlsx'});
      gtag('event', 'click', {
        'file_name': 'TSP Monthly Report 2025.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'TSP Monthly Report 2025.xlsx'});
      fileSaver.saveAs('../../../assets/templates/TSP Monthly Report 2025.xlsx', 'TSP Monthly Report 2025.xlsx');
    } else if (shipmentType === 'baselinerates') {
      gtag('event', 'file_download', {
        'file_name': '1000-D_Section_B_05082014.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': '1000-D_Section_B_05082014.pdf'});
      gtag('event', 'click', {
        'file_name': '1000-D_Section_B_05082014.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': '1000-D_Section_B_05082014.pdf'});
      fileSaver.saveAs('../../../assets/templates/1000-D_Section_B_05082014.pdf', '1000-D_Section_B_05082014.pdf');
    } else if (shipmentType === 'stos') {
      gtag('event', 'file_download', {
        'file_name': 'STOS NINETH Edition final verszion.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'STOS NINETH Edition final verszion.pdf'});
      gtag('event', 'click', {
        'file_name': 'STOS NINETH Edition final verszion.pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'STOS NINETH Edition final verszion.pdf'});
      fileSaver.saveAs('../../../assets/templates/STOS NINETH Edition final verszion.pdf', 'STOS NINETH Edition final verszion.pdf');
    } else if (shipmentType === 'uniformrules') {
      gtag('event', 'file_download', {
        'file_name': 'GSA_No_200-A_Uniform_Rules_Tariff (07.17.25).pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'GSA_No_200-A_Uniform_Rules_Tariff (07.17.25).pdf'});
      gtag('event', 'click', {
        'file_name': 'GSA_No_200-A_Uniform_Rules_Tariff (07.17.25).pdf',
        'file_extension': 'pdf',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'GSA_No_200-A_Uniform_Rules_Tariff (07.17.25).pdf'});
      fileSaver.saveAs('../../../assets/templates/GSA_No_200-A_Uniform_Rules_Tariff (07.17.25).pdf', 'GSA_No_200-A_Uniform_Rules_Tariff (07.17.25).pdf');
    } else if (shipmentType === 'frtDlvry') {
      gtag('event', 'file_download', {
        'file_name': 'Shipments_DeliveryReport_Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'Shipments_DeliveryReport_Template.xlsx'});
      gtag('event', 'click', {
        'file_name': 'Shipments_DeliveryReport_Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'Shipments_DeliveryReport_Template.xlsx'});
      fileSaver.saveAs('../../../assets/templates/Shipments_DeliveryReport_Template.xlsx', 'Shipments_DeliveryReport_Template.xlsx');
    } else if (shipmentType === 'hhgratefilinginstr') {
      gtag('event', 'file_download', {
        'file_name': 'HHG Rate Filing Instructions.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'HHG Rate Filing Instructions.xlsx'});
      gtag('event', 'click', {
        'file_name': 'HHG Rate Filing Instructions.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'HHG Rate Filing Instructions.xlsx'});
      fileSaver.saveAs('../../../assets/templates/HHG Rate Filing Instructions.xlsx', 'HHG Rate Filing Instructions.xlsx');
    } else if (shipmentType === 'xtosratefilinginstr') {
      gtag('event', 'file_download', {
        'file_name': 'XTOS_TEMPLATE_Instructions.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'XTOS_TEMPLATE_Instructions.xlsx'});
      gtag('event', 'click', {
        'file_name': 'XTOS_TEMPLATE_Instructions.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'XTOS_TEMPLATE_Instructions.xlsx'});
      fileSaver.saveAs('../../../assets/templates/XTOS Rate Filing Instructions _2024_2025.xlsx', 'XTOS Rate Filing Instructions.xlsx');
    }
    else if (shipmentType === 'hhg_xtos') {
      gtag('event', 'file_download', {
        'file_name': 'CHAMP_XTOS Report_Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'file_download',
        'link_url': 'CHAMP_XTOS Report_Template.xlsx'});
      gtag('event', 'click', {
        'file_name': 'CHAMP_XTOS Report_Template.xlsx',
        'file_extension': 'xlsx',
        'interaction_type': 'Mouse Click',
        'event_name_dimension': 'click',
        'link_url': 'CHAMP_XTOS Report_Template.xlsx'});
      fileSaver.saveAs('../../../assets/templates/CHAMP_XTOS Report_Template.xlsx', 'CHAMP_XTOS Report_Template.xlsx');
    }
  }

}
